import { useSelector } from 'react-redux';
import styles from './NotificationIcon.module.css';
import { IoNotificationsOutline } from 'react-icons/io5';

function NotificationIcon() {
  const unseenNotifications = useSelector(
    (state) => state.notifications.unreadCount > 0
  ); // This should be replaced with actual logic to check for unseen notifications
  return (
    <div
      className={`${styles.NotificationIcon} ${
        unseenNotifications && styles.NotificationsUnseen
      }`}
    >
      <IoNotificationsOutline
        size={28}
        style={{ color: 'var(--Warning_Color)' }}
      />
    </div>
  );
}

export default NotificationIcon;
